export default {
    "fit": "fit",
    "flip": "flip"
};



//////////////////
// WEBPACK FOOTER
// c:/Projects/YuDRIV/ServicesAPI/YuDriv-ServicesAPI/Enforcement/~/@progress/kendo-popup-common/dist/es/collision.js
// module id = ../../../../@progress/kendo-popup-common/dist/es/collision.js
// module chunks = 3